// extracted by mini-css-extract-plugin
module.exports = {"popup":"popup_popup__e5EAM","content":"popup_content__rLUFN","bg":"popup_bg__2_mwx","close":"popup_close__P8Ci1"};